import React from "react";

const LazyGroupTvImage = React.lazy(() => import("./tv-image"));

const GroupTvImage = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/running-horse.gif' /></div>}>
    <LazyGroupTvImage {...props} />
  </React.Suspense>
);

export default GroupTvImage;
